<template>
  <div id="print">
    <!-- 头部搜索/按钮/日历 -->
    <div class="topBar">
      <div class="right_content canlendar">
        <div
          class="dateInfo"
        >{{selectedDayInfo.year}}-{{selectedDayInfo.month}}-{{selectedDayInfo.date}}</div>
        <!-- <div style="clear: both;"></div> -->
        <div class="selectBar">
          <img src="../../assets/images/icons/left.png" @click="showPre" class="preBtn" />
          <div class="dateBar">
            <div v-for="(item, index) in weekData" :key="index" @click="selectDate(item, index)">
              <div class="day">{{item.day}}</div>
              <div class="date" :class="{'active': selectedDateIndex == index}">{{item.date}}</div>
            </div>
          </div>
          <img src="../../assets/images/icons/right.png" @click="showNext" class="nextBtn" />
        </div>
      </div>
    </div>

    <div class="table_wrap" :style="{height: timeData.length*30+250+'px'}">
      <div class="left_fixed">
        <!-- 表头 -->

        <div class="check_all_button">
          <input
            type="checkbox"
            id="allIn"
            :value="checkValue"
            v-model="checkedNamesAllIn"
            :checked="checkedNamesAllIn"
            @click="getCheckAll"
          />
          <span>{{$t('m.SelectAll')}}</span>
        </div>

        <!-- 表体 -->
        <div class="table_fixed_terminal">
          <div v-for="(item, index) in timeData" class="timeTr" :key="index">
            <div class="titleBlock">
              <input
                type="checkbox"
                id="runoob"
                :value="item.id"
                :disabled="checkedNamesUnabel.includes(item.id)"
                v-model="checkedNames"
                class="Input"
              />
              <span class="conviction" v-if="item.type==2">预</span>
              <span class="Text">{{item.title}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="dayInfoContainer" id="d1" >
        <div class="timeBar">
          <div v-for="(item, index) in timeList" :key="index">{{item}}</div>
        </div>
        <div class="timeTable">
          <div v-for="(item, index) in timeData" class="timeTr" :key="index">
            <div class="blankBlock">
              <div
                @touch="btnClick(item,index,innerIndex)"
                v-for="(item2, innerIndex) in item.data"
                :class="{active: item2.isActive}"
                :style="{ position: 'absolute', width: item2.width, left: item2.offset }"
              >{{item2.name}}</div>
            </div>
          </div>
          <div
            class="tableLine"
            :style="{ left: item,height: timeData.length*30+'px' }"
            v-for="(item, index) in tableLineOffset"
          ></div>
           
          <!--这个终端所在的会议内容-->
          <div
            class="messageInfo"
            v-show="messageInfoDetails"
            ref="messageInfo"
            :style="{'left':messageLeft,'top':messageTop}"
          >
            <p>{{$t('m.MeetingDetails')}}</p>
            <ul>
              <li>
                <span>-</span>
                <span>{{$t('m.TerminalName')}}</span>
                <span>{{messageOfTerminal}}</span>
              </li>
              <li>
                <span>-</span>
                <span>{{$t('m.MeetingTime')}}</span>
                <span>{{messageOfCfTime}}</span>
              </li>
              <li>
                <span>-</span>
                <span>{{$t('m.MeetingDuration')}}</span>
                <span>{{messageOfCfLong}}</span>
              </li>
              <li>
                <span>-</span>
                <span>{{$t('m.MeetingCreatorColon')}}</span>
                <span>{{messageOfCfCreate}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="findDevOccupiedInfo">
             <p>{{$t('m.OccupiedResources')}}{{occupied}}/{{total}}{{$t('m.OccupiedSummary')}}</p>
       </div>
      </div>
    </div>
    <div class="bottomButtons">
      <div @click="sub" class="bgc">{{$t('m.OKBtn')}}({{checkedNamesLength}})</div>
    </div>
  </div>
</template>
<script>
import {
  creatMeeting,
  getAllTerminals,
  findTerminalListAndCalendar,
  findDevOccupied,
  addterminal
} from "../../assets/js/url";
import "../../../static/css/normalize3.0.2.min.css";
import "../../..//static/css/style.css?v=7";
import "../../..//static/css/mobiscroll.css";
import "../../..//static/css/mobiscroll_date.css";

export default {
  name: "calendar",
  props: {
    //从上一个页面传来的值
    loadInfo: Object,
    allTerminalsList: Array
  },
  data() {
    return {
      formItem: {
        input: ""
      },
      checkValue: false,
      checkedNamesAllIn: false,
      type: "",
      model: false,
      dataInfo: "",
      firstDataInfo: "", //从别的页面传过来的时间点
      onloadIfon: {
        terDirectList: []
      },
      weekData: [],
      occupied: "",
      total: "",
      weekday: [
        this.$t('m.Sunday'),
        this.$t('m.Monday'),
        this.$t('m.Tuesday'),
        this.$t('m.Wednesday'),
        this.$t('m.Thursday'),
        this.$t('m.Friday'),
        this.$t('m.Saturday')
      ],
      selectedDateIndex: 0,
      selectedDayInfo: {},
      pageNo: 0,
      checkedNames: [],
      messageInfoDetails: false,
      timeList: [
        "0:00",
        "1:00",
        "2:00",
        "3:00",
        "4:00",
        "5:00",
        "6:00",
        "7:00",
        "8:00",
        "9:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00"
      ],
      timeData: [], //日历里的信息
      tableLineOffset: [],
      meeting: {
        cf_terminal: ""
      },

      meetingId: "",
      cf_id: "",
      mcuId: "",

      actionType: -1,
      messageLeft: 0, //点击终端里的会议弹出的详情
      messageTop: 0,
      messageOfTerminal: "",
      messageOfCfTime: "",
      messageOfCfLong: "",
      messageOfCfCreate: "",

      clickIndex: -1,
      clickInnerIndex: -1,
      // queryParams: "",
      pickMeetingcfterminal: [], //选择的终端id
      pickMeetingcfterminalname: [], //选择的终端name
      checkAllArr: [],
      checkedNamesLength: 0,
      confirmstatus: true,
      pickSingleTerminals: [],
      checkedNamesUnabel:[]
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    checkAllCanUse(){
      for(let i=0;i<this.checkedNamesUnabel.length;i++){
        for(let j=0;j<this.checkedNames.length;j++){
          if(this.checkedNamesUnabel[i] == this.checkedNames[j]){
            return true
          }
        }
      }
      return false;
    }
  },
  created() {},
  mounted() {},
  activated() {
    document.getElementById("d1").scrollLeft = 670;
    //初始化数据
    this.initmessage();
    this.loadWeekData();
    this.selectedDayInfo = this.getDate(0); //被选中的日期,是从建会那边过来的时间
    //获取资源情况
    // this.findDevOccupiedInfo(this.onloadIfon.id,0,'');
    let Message = this.$route.query.message;
    let MeetingterminalList = this.$route.query.MeetingterminalList;
    if (Message) {
      Message = Message.split(',')
      this.checkedNames = (Message);
      if("name" in this.$route.query){
        this.checkedNamesUnabel = [];
      }else{
        this.checkedNamesUnabel = (Message);
      }
    }else if(MeetingterminalList){
      MeetingterminalList = JSON.parse(MeetingterminalList);
      this.checkedNames = MeetingterminalList;
      this.checkedNamesUnabel = MeetingterminalList;
    } else {
      this.checkedNames = [];
      this.checkedNamesUnabel = []
    }
    let Tlist=this.$route.query.Tlist;
     if (Tlist) {
      this.checkAllArr = (Tlist);
    } else {
      this.checkAllArr = [];
    }
  },

  methods: {
    Click(item) {
      let Index = this.checkedNames.indexOf(item.id);
      if(this.checkedNamesUnabel.includes(item.id)){
        return;
      }

      if (Index == -1) {
        this.checkedNames.push(item.id);
        this.checkAllArr.push(item.id);
      } else {
        this.checkedNames.splice(Index, 1);
        this.checkAllArr.splice(Index, 1);
      }
    },
    getCheckAll() {
      if (!this.checkedNamesAllIn) {
        this.checkAllArr = [];
        let onloadIfonList=[]
        this.onloadIfon.terDirectList.map(item=>{onloadIfonList.push({id:item.id,name:item.name})})
        // 勾选全选
        this.pickMeetingcfterminal = [];
        this.pickMeetingcfterminalname = [];
        this.checkAllArr = this.checkAllArr.concat(
          this.onloadIfon.terDirectList,
          this.pickSingleTerminals
        );
        this.checkAllArr = Array.from(new Set(this.checkAllArr));
        this.checkAllArr.forEach((item, index) => {
          if(!this.checkedNamesUnabel.includes(item.id)){
            this.pickMeetingcfterminal.push(item.id);
            this.pickMeetingcfterminalname.push(item.name);
          }
        });
        this.checkedNames = Array.from(new Set(this.pickMeetingcfterminal)); // 勾选所有终端
        this.checkedNames = this.checkedNames.concat(this.checkedNamesUnabel);
        this.pickMeetingcfterminal = this.pickMeetingcfterminal.join(",");
        this.pickMeetingcfterminalname = this.pickMeetingcfterminalname.join(
          ","
        );
      } else {
        // 取消全选
        this.pickMeetingcfterminal = [];
        this.pickMeetingcfterminalname = [];
        for (let i = 0; i < this.loadInfo.terDirectList.length; i++) {
          for (let j = 0; j < this.checkedNames.length; j++) {
            if (this.loadInfo.terDirectList[i].id == this.checkedNames[j]) {
              this.checkedNames.splice(j, 1);
              // j--;
            }
          }
        };

        this.pickSingleTerminals.forEach((item, index) => {
          if(!this.checkedNamesUnabel.includes(item.id)){
          this.pickMeetingcfterminal.push(item.id);
          this.pickMeetingcfterminalname.push(item.name);
          };
          
        });

        this.checkedNames = this.checkedNames.concat(this.checkedNamesUnabel);
        this.checkedNames = Array.from(new Set(this.checkedNames))
      }
    },
    // childSearch() {
    //   this.$emit("childSearchValue", this.formItem.input);
    // },
    //--如果从父级页面有数据来，需要初始化勾选状态
    initmessage() {
      this.checkedNames = [];

      //终端信息数据
      const query = this.$route.query;
      // this.queryParams = query.isDisabled;
      if ("name" in query) {
        //如果有这个属性说明是从【终端管理】模块或者 建会里过来的
        //如果有带一个时间，要加载这个时间的信息
        if ("dateTimeValue" in query) {
          //从建会里过来的
          this.firstDataInfo = query.dateTimeValue;
          if (this.firstDataInfo == "") {
            this.firstDataInfo = this.getCurrentDate(); //获取当前的时间
          }
          this.terminalIds = query.message;
          if (query.message) {
            let dataStrArr = query.message.split(",");
            let dataIntArr = [];
            dataStrArr.forEach(item => {
              dataIntArr.push(+item);
            });
            this.checkedNames = dataIntArr;
          }
          this.actionType = 0;
        } else {
          //会控终端模块过来的
          this.firstDataInfo = this.getCurrentDate();
          // this.checkedNames = query.messsage.split(',');
          // this.checkedNamesUnabel = query.messsage.split(',');
          this.actionType = 1;
        }
      } else {
        //会控里的增加终端，需要会议信息 ，不需要会议信息
        this.mcuId = query.mcuId;
        this.cf_id = query.cf_id;
        this.meetingId = query.meetingId;
        this.firstDataInfo = this.getCurrentDate();
        this.actionType = 2;
        // this.checkedNames = query.messsage.split(',');
        // this.checkedNamesUnabel = query.messsage.split(',');
      }
      this.dataInfo = this.firstDataInfo;
      this.$emit("childFn", this.actionType, this.mcuId, this.cf_id); //向父组件传值
    },
    //1.加载终端列表和日历数据 赋值给timeData
    fristGetInfo(initWeekData) {
      let arr = [];
      arr = [...this.onloadIfon.allTerIdList];
      let terIds = "";
      arr.forEach((item, index) => {
        terIds += item + ",";
      });
      terIds = terIds.substring(0, terIds.length - 1);
      this.$http
        .post(findTerminalListAndCalendar, {
          useruuid: window.sessionStorage.getItem("UUID"),
          time: this.dataInfo,
          terIds: terIds
        })
        .then(
          res => {
            if (res.data.status === 2000) {
              this.timeData = res.data.data;
              this.loadWeekData();
              // if (initWeekData) {
              //   this.loadWeekData(); //请求成功后再加载loadWeekData  第一次请求时候需要，之后不需要
              // }
            } else {
              this.$toast(res.data.data); //弹出错误信息
            }
          },
          err => {
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },

    //3.获取当前日期
    getCurrentDate() {
      let time = new Date();
      let year = time.getFullYear();
      let Month = time.getMonth() + 1;
      if (Month < 10) {
        Month = "0" + Month;
      }
      let CurrentDate = time.getDate();
      if (CurrentDate < 10) {
        CurrentDate = "0" + CurrentDate;
      }
      let dataInfo = year + "-" + Month + "-" + CurrentDate + " " + "00:00:00";
      return dataInfo;
    },
    //加载日历
    loadWeekData() {
      if(this.pageNo==0){
        this.weekData = [];
        for (let i = 0; i < 7; i++) {
          let day = this.getDate(i);
          this.weekData.push(day);
        }
        // this.selectedDayInfo = this.getDate(0); //被选中的日期,是从建会那边过来的时间
      }
      

      for (let i = 0; i < 24; i++) {
        let offset = i * 86 + 20;
        this.tableLineOffset[i] = offset + "px";
      }

      for (let i = 0; i < this.timeData.length; i++) {
        if (this.timeData[i].data.length) {
          for (let j = 0; j < this.timeData[i].data.length; j++) {
            let startTime =
              Number(this.timeData[i].data[j].start.split(":")[0]) * 60 +
              Number(this.timeData[i].data[j].start.split(":")[1]);
            let endTime =
              Number(this.timeData[i].data[j].end.split(":")[0]) * 60 +
              Number(this.timeData[i].data[j].end.split(":")[1]);
            let offset = startTime * 1.43;
            let width = (endTime - startTime) * 1.43;
            this.timeData[i].data[j]["offset"] = offset + "px";
            this.timeData[i].data[j]["width"] = width + "px";
          }
        }
      }
    },
    //获取每天日期详情
    getDate(num) {
      let today = this.convertDateFromString(this.firstDataInfo);
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * num;
      today.setTime(targetday_milliseconds);

      let year = today.getFullYear();
      let month = today.getMonth() + 1;
      let date = today.getDate();
      let day = today.getDay();
      let dayStr = this.weekday[day];
      let dateInfo = {
        year: year,
        month: month,
        date: date,
        day: dayStr
      };
      return dateInfo;
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var arr1 = dateString.split(" ");
        var sdate = arr1[0].split("-");
        var date = new Date(sdate[0], sdate[1] - 1, sdate[2]);
        return date;
      }
    },
    //选择日期
    selectDate(item, index) {
      this.selectedDateIndex = index;
      this.selectedDayInfo = item;
      let year = item.year;
      let month = item.month < 10 ? "0" + item.month : item.month;
      let date = item.date < 10 ? "0" + item.date : this.selectedDayInfo.date;
      this.dataInfo = year + "-" + month + "-" + date + " " + "00:00:00";
      this.fristGetInfo(false); //选择日期后再请求数据
    },
    //向前一天切换日期
    showPre() {
      //                if (this.pageNo > 0) {
      this.pageNo = this.pageNo-7;
      this.weekData = [];
      for (let i = this.pageNo; i < 7 + this.pageNo; i++) {
        let day = this.getDate(i);
        this.weekData.push(day);
      }
      this.selectedDayInfo = this.weekData[this.selectedDateIndex]; //被选中的日期
      //拿到切换的时间
      let year = this.selectedDayInfo.year;
      let month =
        this.selectedDayInfo.month < 10
          ? "0" + this.selectedDayInfo.month
          : this.selectedDayInfo.month;
      let date =
        this.selectedDayInfo.date < 10
          ? "0" + this.selectedDayInfo.date
          : this.selectedDayInfo.date;
      this.dataInfo = year + "-" + month + "-" + date + " " + "00:00:00";
      this.fristGetInfo(false);

      //                } else {
      //                    return;
      //                }
    },
    //向后一天  切换日期
    showNext() {
      this.pageNo = this.pageNo+7;

      this.weekData = [];
      for (let i = this.pageNo; i < 7 + this.pageNo; i++) {
        let day = this.getDate(i);

        this.weekData.push(day);
      }
      this.selectedDayInfo = this.weekData[this.selectedDateIndex];

      let year = this.selectedDayInfo.year;
      let month =
        this.selectedDayInfo.month < 10
          ? "0" + this.selectedDayInfo.month
          : this.selectedDayInfo.month;
      let date =
        this.selectedDayInfo.date < 10
          ? "0" + this.selectedDayInfo.date
          : this.selectedDayInfo.date;
      this.dataInfo = year + "-" + month + "-" + date + " " + "00:00:00";

      this.fristGetInfo(false);
    },
    //鼠标点击获取详情
    btnClick(item, index, innerIndex) {
      if (this.clickIndex == index && this.clickInnerIndex == innerIndex) {
        //如果点击的是同一个地方
        this.messageInfoDetails = !this.messageInfoDetails;
        this.$set(item.data[innerIndex], "isActive", this.messageInfoDetails);
      } else {
        //计算位置
        this.messageLeft =
          event.srcElement.offsetLeft + event.srcElement.clientWidth / 2 + "px";
        this.messageTop = event.srcElement.offsetTop + (index + 1) * 30 + "px"; //35px是每行的高度
        this.messageOfTerminal = item["title"];
        this.messageOfCfTime = item.data[innerIndex]["start"].substring(0, 8);
        this.messageOfCfLong = item.data[innerIndex]["meetingLong"] + "分钟";
        this.messageOfCfCreate = item.data[innerIndex]["createUserName"];
        this.messageInfoDetails = true; //不同地方就设为true
        this.clickIndex = index;
        this.clickInnerIndex = innerIndex;
      }
    },
    // btnLeave() {
    //   this.messageInfo = false;
    // },
    goBack() {
      this.$router.go(-1);
      // this.checkedNamesAllIn = "";
      // this.$store.state.meeting.cfterminal = "";
      // this.$store.state.meeting.cfterminalname = "";
    },
    //增加终端
    sub() {
      console.log(this.pickMeetingcfterminal)
      let pm = this.pickMeetingcfterminal.split(',');
      let pmn = this.pickMeetingcfterminalname.split(',');

      for(let i=0;i<pm.length;i++){
        for(let j=0;j<this.checkedNamesUnabel.length;j++){
          if(pm[i]==this.checkedNamesUnabel[j]){
            pm.splice(i,1)
            pmn.splice(i,1)
          }
        }
      }
      pmn = Array.from(new Set(pmn))
      pm = Array.from(new Set(pm))
      this.pickMeetingcfterminalname = pmn.toString();
      this.pickMeetingcfterminal = pm.toString();

      

      this.$store.commit(
        "setmeetingcfterminalname",
        this.pickMeetingcfterminalname
      );
      this.$store.commit("setmeetingcfterminal", this.pickMeetingcfterminal);

      if (this.actionType == 2 && this.pickMeetingcfterminal!='') {
        // let hasTerminalArr = this.$route.query.messageTerminal;
        // let pickTerminalArr = [];
        // let ids = this.$store.state.meeting.cfterminal.split(",");
        // let names = this.$store.state.meeting.cfterminalname.split(",");
        // for (let i = 0; i < ids.length; i++) {
        //   for (let j = 0; j < names.length; j++) {
        //     pickTerminalArr.push({
        //       id: ids[i],
        //       name: names[j]
        //     });
        //   }
        // }
        // for (let i = 0; i < hasTerminalArr.length; i++) {
        //   for (let j = 0; j < pickTerminalArr.length; j++) {
        //     if (hasTerminalArr[i] == pickTerminalArr[j].id) {
        //       this.$toast(
        //         pickTerminalArr[j].name + "已在列表终端，不能再次增加"
        //       );
        //       return;
        //     }
        //   }
        // }
        this.$http
          .post(addterminal, {
            userUUId: window.sessionStorage.getItem("UUID"),
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"), //要增加的终端
            addTerminaliUUId: this.$store.state.meeting.cfterminal
          })
          .then(
            res => {
              if (res.data.status == 2000) {
                this.$toast(this.$t('m.TerminalAddOK'));
                this.checkedNamesAllIn = false;
                this.$store.commit("setmeetingcfterminal", "");
                this.$store.commit("setmeetingcfterminalname", "");
                this.$router.push({
                  path: "/meetingact",
                  query: {
                    cf_id: this.cf_id,
                    mcuId: this.mcuId
                  }
                });
              } else {
                this.$toast(res.data.data);
              }
              
            },
            err => {
              this.$toast(this.$t('m.NetworkException'));
            }
          );
      } else if (this.actionType == 0 || this.$route.query.toattendmeeting == "attendmeeting") {
        if(this.$route.query.fromrouter == '/changemeeting'){
          window.sessionStorage.setItem("_meeting",JSON.stringify(this.$route.params.meetingData))
          this.$router.push({
            name:"changemeeting",
            params:{
              from:'terminalcontrolPctest'
            }
          });
          return;
        }
        this.$router.push("/attendmeeting");
      } else {
        this.$router.go(-1);
      }
    },
    //获取资源占用情况
    findDevOccupiedInfo() {
      this.$http
        .post(findDevOccupied, {
          depmentId: Number(this.onloadIfon.id),
          time: this.onloadIfon.creatingTime || '',
          vmrId: this.onloadIfon.meeting_vrmId || 0
        })
        .then(res => {
          if (res.data.status === 2000) {
            this.occupied = res.data.data.occupied;
            this.total = res.data.data.total;
          }
        });
    },
    isContained(a, b) {
      if (!(a instanceof Array) || !(b instanceof Array)) return false;
      if (a.length < b.length) return false;
      if (b.length == 0) return false;
      // var aStr = a.toString();
      for (var i = 0, len = b.length; i < len; i++) {
        if (a.indexOf(b[i]) == -1) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    loadInfo(newval, oldval) {
      this.checkedNamesAllIn = false;
      this.onloadIfon = newval;
      this.fristGetInfo(true); //通过父级页面拿到数据后，请求数据

      let value = this.isContained(this.checkedNames, newval.allTerIdList);
      if (!value) {
        this.checkedNamesAllIn = false;
        this.checkValue = false;
      } else {
        this.checkedNamesAllIn = true;
      }
      this.findDevOccupiedInfo();
    },
    //watch 选择的复选框 去除id  然后  vuex 存储
    checkedNames(val, oldval) {
      this.checkedNamesLength = val.length;
      //勾选终端的时候
      this.pickMeetingcfterminal = [];
      this.pickMeetingcfterminalname = [];
      let arr = [];
      val.forEach((key, index) => {
        this.allTerminalsList.forEach(item => {
          if (item.id == key) {
            arr.push(item);
          }
        });
      });
      arr.forEach((item, index) => {
        this.pickMeetingcfterminal.push(item.id);
        this.pickMeetingcfterminalname.push(item.name);
      });
      this.pickSingleTerminals = arr; // 一个一个打勾的
      this.pickMeetingcfterminal = this.pickMeetingcfterminal.join(",");
      this.pickMeetingcfterminalname = this.pickMeetingcfterminalname.join(",");
      let a = new Set(val);
      let b = new Set(oldval);
      let d = Array.from(new Set([...b].filter(x => !a.has(x))));
      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < this.checkAllArr.length; j++) {
          if (d == this.checkAllArr[j].id) {
            this.checkAllArr.splice(j, 1);
            j--;
          }
        }
      }
      let value = this.isContained(val, this.onloadIfon.allTerIdList);
      if (value) {
        this.checkedNamesAllIn = true;
      } else {
        this.checkedNamesAllIn = false;
        this.checkValue = false;
      }
    }
  }
};
</script>

<style scoped>
.active {
  color: #fff !important;
  background-color: #aabed7 !important;
}
.searchList {
  display: inline-block;
  margin-top: 20px;
  margin-left: 11px;
}
.searchList input {
  width: 283px;
}
.right_content {
  display: flex;
}
.canlendar {
  margin-left: 40px;
}
.selectBar {
  /* float: right; */
  width: 430px;
}
.backbtn {
  font-size: 15px;
  margin-top: 0.159rem;
  margin-left: 25px;
}
.dateBar {
  display: inline-flex;
  justify-content: space-between;
  width: 88%;
}
.dateBar > div {
  text-align: center;
}
.dateBar .day {
  color: #999;
  margin-bottom: 5px;
}
.dateBar .date {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  line-height: 30px;
  cursor: pointer;
}
.dateBar .date.active {
  color: #fff;
}
.preBtn {
  display: inline-block;
  width: 4%;
  position: relative;
  top: 15px;
  margin-right: 1%;
  cursor: pointer;
}
.nextBtn {
  display: inline-block;
  width: 4%;
  position: relative;
  top: 15px;
  margin-left: 1%;
  cursor: pointer;
}
.dateInfo {
  width: 135px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1.5px solid #666;
  height: 45px;
  line-height: 45px;
  /* float: right; */
}
.topBar {
  display: flex;
  margin: 10px;
  justify-content: space-between;
  /* align-items: center; */
  margin-left: -0.18rem;
}
.table_wrap {
  box-shadow: 0 0 5px 1px rgb(238, 238, 238);
  display: flex;
  overflow: hidden;
}
.dayInfoContainer {
  width: 101%;
  height: 100%;
  border: 1px solid rgb(238, 238, 238);
  box-shadow: 0 0 5px 1px rgb(238, 238, 238);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 10;
  /* overflow: hidden ; */
}
.timeBar {
  width: 100%;
  height: 40px;
  display: flex;
  width: 2300px;
  padding: 10px 0 10px 150px;
  padding: 10px 20px;
  border-bottom: 1px solid rgb(238, 238, 238);
  box-shadow: 0px 5px 5px -5px rgb(238, 238, 238);
}
.left_fixed .check_all_button {
  width: 135px;
  height: 40px;
  padding: 10px 0 10px 150px;
  padding: 10px 20px;
  border-bottom: 1px solid rgb(238, 238, 238);
  box-shadow: 0px 5px 5px -5px rgb(238, 238, 238);
}
.table_fixed_terminal {
  padding: 10px;
  overflow: hidden;
}
.timeBar > div {
  width: 86px;
  height: 100%;
}
.timeBar > div:last-child {
  width: 50px;
}
.timeTable {
  width: 2300px;
  padding: 10px 20px;
  position: relative;
}
.timeTable .timeTr {
  width: 100%;
  height: 30px;
}
.titleBlock {
  width: 130px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  margin: 0 10px 0 5px;
  padding: 0 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom: 2px solid #fff;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.blankBlock {
  width: 2068px;
  height: 30px;
  display: inline-block;
  border: 2px solid rgb(238, 238, 238);
  border-top: none;
  position: relative;
}
.blankBlock > div {
  background-color: #ecf0f5;
  color: #86939d;
  height: 25px;
  line-height: 25px;
  top: 3px;
  z-index: 9;
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.timeTable .timeTr:first-child .blankBlock {
  border-top: 2px solid rgb(238, 238, 238);
}
.tableLine {
  border-right: 2px solid rgb(238, 238, 238);
  position: absolute;
  top: 10px;
}
.messageInfo {
  display: inline-block;
  width: 200px;
  height: 200px;
  background: white;
  color: black;
  padding: 10px;
  position: absolute;
  z-index: 99999;
}
.messageInfo p {
  font-size: 12px;
  border-bottom: 2px solid #f6f3f3;
  padding-bottom: 7px;
}

.messageInfo ul li span:first-child {
  color: #32af66;
  font-weight: 800;
}
.messageInfo ul li span:nth-child(2) {
  color: #86939d;
}
.messageInfo ul li {
  margin-bottom: 20px;
  margin-top: 10px;
  box-shadow: #999;
}
.makeSure {
  display: inline-block;
  margin-left: 21px;
  margin-top: 9px;
  background: #32af66;
  width: 100px;
  height: 34px;
  line-height: 34px;
  border-radius: 5px;
  text-align: center;
  color: white;
  font-size: 15px;
}
.findDevOccupiedInfo {
  text-align: right;
  margin: 20px;
}
.findDevOccupiedInfo p {
  font-size: 15px;
}
.bottomButtons {
  width: 100%;
  /* display: flex; */
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.bottomButtons > div {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  border: 1px solid #f3f3f3;
}
/* .hha{
        width: 87px;
        height: 70px;
        background: red;
    } */
.conforim {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.conforim > div {
  width: 100%;
  height: 0.25rem;
  line-height: 0.25rem;
  color: #fff;
  font-size: 0.12rem;
  text-align: center;
  border: 1px solid #f3f3f3;
}
.Input {
  vertical-align: middle;
  height: 16px;
  width: 16px;
}
.Text {
  vertical-align: middle;
}
.conviction {
  display: inline-block;
  height: 14px;
  width: 14px;
  line-height: 14px;
  background: #fff;
  color: pink;
  text-align: center;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/content/calendar.vue